import React from 'react';
import { ShoppingBag } from 'lucide-react';
import RedirectPage from '../components/RedirectPage';

const Shop = () => {
  return (
    <RedirectPage
      title="Team Shop"
      description="You're being redirected to our official Cardinals team store. The store will open in a new tab."
      url="https://lccstore.printful.me/"
      icon={<ShoppingBag className="w-8 h-8 text-[#8B0000]" />}
    />
  );
};

export default Shop;